module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-70ae6356.png";